import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteJiraCredentialsRequest = {
	customerId: number;
};

export const deleteJiraCredentials = createDeleteEndpoint<DeleteJiraCredentialsRequest>('/api/v3/jira');
